import {Model} from "@vuex-orm/core";

import Building from "@models/building/Building";
import Room from "@models/building/Room";
import Unitairvolume from "@models/airvolumes/Unitairvolume";
import Systemselection from "@models/airvolumes/Systemselection";
import Installation from "@models/airvolumes/Installation";

import store from "@store";
import pageValidation from "@services/validations/pageValidation";
import StoredArticle from "@models/articles/StoredArticle";

export default class Unit extends Model {
  static entity = "units";

  get infiltrationString() {
    return parseFloat(this.infiltration).toFixed(1);
  }

  get moisureProtectionString() {
    return parseFloat(this.moisureProtection).toFixed(1);
  }

  static fields() {
    return {
      id: this.uid(),
      buildingId: this.attr(null),

      name: this.string("WE 1"),

      storey: this.number(1),
      level: this.number(null).nullable(),
      multiStorey: this.number(0),

      fireplace: this.number(null).nullable(),
      windowless: this.number(null).nullable(),
      occupancy: this.number(0),
      occupancyDisabled: this.boolean(false),
      peopleNumber: this.number(null).nullable(),

      height: this.number(2.5),
      space: this.number(null).nullable(),
      volume: this.number(null).nullable(),

      infiltration: this.number(null).nullable(),
      moisureProtection: this.number(null).nullable(),
      overflowSeal: this.number(0),

      testArticles: this.attr(null),

      //airvolumes
      ventilationMeasure: this.number(null).nullable(),
      rooms: this.hasMany(Room, "unitId"),
      airvolume: this.hasOne(Unitairvolume, "unitId"),
      systemselection: this.hasOne(Systemselection, "unitId"),
      installation: this.hasOne(Installation, "unitId"),

      //articles
      articles: this.hasMany(StoredArticle, "unit_id"),
      selectedDevice: this.attr(null).nullable(),
      device: this.attr(null).nullable(),

      //userArticles: [],
      deviceType: this.attr(0),
      deviceControll: this.attr(0),
      deviceFilter: this.attr([0, 0, 0, 0, 1]),

      articleUpdate: this.attr(true),
      equipmentUpdate: this.attr(true),
      airvolumeUpdate: this.attr(true),
      deviceEquipmentUpdate: this.attr(false),

      deviceEquipmentAccessorygroups: this.attr([]),
      equipmentAccessorygroups: this.attr([]),

      mountingPosition: this.boolean(false),

      //AT Norm
      co2voc: this.boolean(false),
    };
  }

  static afterUpdate(model) {
    if (store.state.navigation.value.index <= 2) pageValidation.validatePossiblePages();
  }

  setDefaultsByType(buildingType = 0) {
    this.peopleNumber = null;
    switch (parseInt(buildingType)) {
      case 0:
        this.multiStorey = 0;
        this.occupancy = 0;
        this.storey = 1;
        this.level = null;
        if (this.ventilationMeasure == 4) {
          this.ventilationMeasure = 3;
        }
        break;
      case 1:
        this.occupancy = 1;
        this.multiStorey = 1;

        if (this.ventilationMeasure == 3) {
          this.ventilationMeasure = 4;
        }
        break;
      case 2:
        this.multiStorey = 1;
        this.occupancy = 1;
        if (this.ventilationMeasure == 4) {
          this.ventilationMeasure = 3;
        }
        break;
    }
    this.setOccupancy();
    return;
  }

  setOccupancy() {
    if (isNaN(this.peopleNumber) || this.peopleNumber <= 0 || this.peopleNumber == null) {
      this.peopleNumber = null;
      this.occupancyDisabled = false;
      return;
    }
    this.peopleNumber = Math.ceil(this.peopleNumber);
    this.occupancyDisabled = true;

    if (isNaN(this.space) || this.space == null) {
      this.space = null;
      return;
    }
    if (this.peopleNumber <= this.space / 40) {
      this.occupancy = 0;
    } else {
      this.occupancy = 1;
    }
  }

  setStory() {
    if (this.storey != 2 || isNaN(this.level)) {
      this.level = null;
    } else {
      this.level = Math.ceil(this.level);
      if (this.level == 0) this.level = null;
    }
  }

  setVolume() {
    if (isNaN(parseFloat(this.space))) {
      this.space = null;
      this.volume = null;
      return;
    }
    if (isNaN(parseFloat(this.height))) {
      this.height = null;
      this.volume = null;
      return;
    }
    this.space = +parseFloat(this.space).toFixed(2);
    this.height = +parseFloat(this.height).toFixed(2);
    this.volume = +parseFloat(this.space * this.height).toFixed(2);
  }

  preCalculations() {
    if (isNaN(parseFloat(this.volume))) {
      this.setVolume();
      return;
    }
    var building = Building.find(this.buildingId);

    let fWs = store.getters["constants/getTable4Constant"]({
      buildingHeatProtection: building.heatProtection,
      unitOccupancy: this.occupancy
    });
    let eZ = store.getters["constants/getTable5Constant"]({
      buildingLocation: building.location,
      unitMultiStorey: this.multiStorey
    });
    let n50 = store.getters["constants/getTable10Constant"]({
      buildingAirtightness: building.airtightness,
      buildingAirExchange: building.airExchange
    });

    //Mindestvolumenstrom zum Feuchteschutz
    this.moisureProtection = +parseFloat(fWs * (-0.002 * Math.pow(this.space, 2) + (1.15 * this.space + 11))).toFixed(1);
    //Volumenstrom durch Infiltration
    this.infiltration = +parseFloat(eZ * this.space * this.height * n50).toFixed(1);
  }

  getPipesAmmount() {
    var exhaustPipes = {round: 0, oval: 0};
    var supplyPipes = {round: 0, oval: 0};
    var totalPipes = {round: 0, oval: 0};
    var rooms = Room.query().where("unitId", this.id).with("valves").get();
    rooms.forEach((room) => {
      room.valves.forEach((valve) => {
        if (!valve || (room.airType != 1 && room.airType != 2)) return;
        if (room.airType == 1 && valve.pipesystem == 1) {
          exhaustPipes.round += parseInt(valve.pipesAmmount);
          totalPipes.round += parseInt(valve.pipesAmmount);
        } else if (room.airType == 1 && valve.pipesystem == 2) {
          exhaustPipes.oval += parseInt(valve.pipesAmmount);
          totalPipes.oval += parseInt(valve.pipesAmmount);
        } else if (room.airType == 2 && valve.pipesystem == 1) {
          supplyPipes.round += parseInt(valve.pipesAmmount);
          totalPipes.round += parseInt(valve.pipesAmmount);
        } else if (room.airType == 2 && valve.pipesystem == 2) {
          supplyPipes.oval += parseInt(valve.pipesAmmount);
          totalPipes.oval += parseInt(valve.pipesAmmount);
        }
      });
    });
    return {exhaustPipes: exhaustPipes, supplyPipes: supplyPipes, totalPipes: totalPipes};
  }

  getPipeProfile() {
    const systemselection = Systemselection.query().where("unitId", this.id).first();
    if (systemselection.pipeProfile == 2) return 63;
    var ovalRooms = Room.query()
      .where("unitId", this.id)
      .whereHas("valves", (query) => {
        query.where("pipesystem", 2);
      })
      .with("valves")
      .exists();
    var roundRooms = Room.query()
      .where("unitId", this.id)
      .whereHas("valves", (query) => {
        query.where("pipesystem", 1);
      })
      .with("valves")
      .exists();
    if (ovalRooms && roundRooms) return "mixed";
    if (ovalRooms) return 51;
    if (roundRooms) return 75;
  }

  getSpecification(__) {
    var building = Building.find(this.buildingId);
    if (building.type != 0) {
      var level = this.level;
      if (this.level == null || this.level == 0) level = "";
      return this.name + ", " + store.state.inputs.floors[this.storey].text + level + ", " + __("lang.kwl.room_overview.total_space") + ": " + parseFloat(this.space).toFixed(2) + " " + __("lang.kwl.room_overview.square_meter");
    } else {
      return this.name + ", " + __("lang.kwl.room_overview.total_space") + ": " + parseFloat(this.space).toFixed(2) + " " + __("lang.kwl.room_overview.square_meter");
    }
  }

  checkSpace() {
    var rooms = Room.query().where("unitId", this.id).get();
    var space = 0;
    rooms.forEach((room) => {
      space += room.space;
      space = +parseFloat(space).toFixed(2);
    });

    return this.space == space;
  }

  deleteArticles() {
    StoredArticle.delete((article) => {
      return article.unit_id == this.id;
    });
    // delete room articles
    var rooms = Room.query().where("unitId", this.id).get();
    rooms.forEach((room) => {
      room.deleteArticles();
    });
  }

  // distributor slection values
  // needed values:
  // pipe profile (75, 63, 51, mixed)
  //  systemselection.pipeProfile == 2 => 63
  //  ovalRooms => 51
  //  roundRooms => 75
  //  ovalRooms && roundRooms => mixed
  // pipe amount (according to accesory id (16 => supply, 17 => exhaust)) depends on systemselection.distributorSystem
  // if systemselection.distributorSystem == 1 => only one distributor
  // if systemselection.distributorSystem == 2 => one distributor per storey
  // return [ {pipeProfile: 75, pipes: {supply: 0, exhaust: 0}}, {pipeProfile: 63, pipes: {supply: 0, exhaust: 0}}]
  distributorSelection(accessoryId) {
    let airType = accessoryId == 16 ? 2 : 1

    const rooms = Room.query()
      .where("unitId", this.id)
      .where("airType", airType)
      .has('valves')
      .with(['valves'])
      .get()

    if (rooms.length == 0) return []

    const systemSelection = Systemselection.query().where("unitId", this.id).first();

    // crate room groups if systemselection.distributorSystem == 1 all rooms are in one group else one group per storey and level
    const roomGroups = {}
    if (systemSelection.distributorSystem == 1) {
      roomGroups[0] = rooms
    } else {
      rooms.forEach(room => {
        const key = room.storey + (room.level ? room.level : '')
        if (!roomGroups[key]) {
          roomGroups[key] = []
        }
        roomGroups[key].push(room)
      })
    }

    const pipeGroups = []
    // generate pipe groups like: {profile: 75, pipes: {supply: 0, exhaust: 0}}
    for (let key in roomGroups) {
      const roomGroup = roomGroups[key]
      let profile = 0
      let pipes = 0

      if (systemSelection.pipeProfile == 2) {
        profile = 63
      }

      roomGroup.forEach(room => {
        if (profile !== 63) {
          if (room.valves[0].pipesystem == 2 && (profile === 0 || profile === 51)) {
            profile = 51
          } else {
            profile = 75
          }
        }

        room.valves.forEach(valve => {
          pipes += valve.pipesAmmount
        })
      })

      pipeGroups.push({profile: profile, pipes: pipes})
    }
    return pipeGroups
  }
}
